import { TextField } from "@mui/material";

function Input(props) {
  const { name, label, value, type, error = null, onChange, ...other } = props;

  return (
    <TextField
      sx={{ width: "100%", margin: "10px 0" }}
      variant="outlined"
      label={label}
      name={name}
      value={value}
      type={type}
      InputProps={{
        style: { color: "var(--txt-color)" },
      }}
      {...other}
      {...(error && { error: true, helperText: error })}
      onChange={onChange}
      InputLabelProps={{
        style: { color: "var(--txt-color)" },
      }}
    />
  );
}

export default Input;
